import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config';
import 'primeicons/primeicons.css';
import './style.css'; // Import Tailwind
import ConfirmationService from 'primevue/confirmationservice';
import Aura from '@primeuix/themes/aura';
import ToastService from 'primevue/toastservice';
import ganttastic from '@infectoone/vue-ganttastic';

import App from './App.vue'
import router from './router'
import Tooltip from 'primevue/tooltip';
import { useAuthStore } from '@/stores/auth';


const app = createApp(App)

const pinia = createPinia()

app.use(pinia)

const authStore = useAuthStore(pinia)
await authStore.initializeAuth()

app.use(router)
app.use(ganttastic)
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      primaryColor: 'blue',
      darkModeSelector: false
    }
  },
  ripple: true
});
app.use(ConfirmationService);
app.use(ToastService);
app.directive('tooltip', Tooltip);

app.mount('#app')
